import 'babel-polyfill'
import 'es6-promise'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './stores/index'
import './styles/globa.less'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/icon/iconfont.css'
import Component from 'vue-class-component'
import userApi from './api/userApi'
import { tokenManager } from './utils/tokenManager'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])
Vue.config.productionTip = false
Vue.use(Antd)

const app = new Vue({
  router,
  store,
  render: h => h(App)
})


console.log('11', app.$route.query.orderNo)

tokenManager.refreshToken().then(() => {
  userApi.getCurrentUserInfo().then(res => {
    if (res.code === 200) {
      if (res.data.accountStatus === 'ENTER_ACCOUNT') {
        app.$store.commit('setCurrentUser', res.data)
        app.$mount('#app')
      } else {
        // app.$warning({
        //   title: '提示',
        //   content: '入住后才能查看资源',
        // });
        if (!app.$route.query.orderNo) {
          location.href = '/user/#/'
        } else {
          app.$store.commit('setCurrentUser', res.data)
          app.$mount('#app')
        }
      }
    }
  }).always(res => {
    app.$mount('#app')
  })
}, (res) => {
  location.href = '/user/#/login'
})


export default app
